import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 3v5h5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3.05 13A9 9 0 1 0 6 5.3L3 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 7v5l4 2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "History";
const History = memo(themed(Icon));
export {
  History
};
//# sourceMappingURL=history.js.map
